module.exports = __webpack_public_path__ + "static/media/icon_11.92f749cd.png";